import { useState } from 'react';
import { useForm } from 'react-hook-form';
// form
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { LoadingButton } from '@mui/lab';
// components
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import useCallApiWithLoading from 'src/hooks/useCallApiWithLoading';
import { useStores } from 'src/models';
import { commonApi } from 'src/service';
import * as Yup from 'yup';

// ----------------------------------------------------------------------

type FormValuesProps = {
  email: string;
};

export default function ResetPasswordForm() {
  const rootStore = useStores();
  const { callApiWithLoading } = useCallApiWithLoading();
  const { alertStore } = rootStore;
  const [isLoading, setIsLoading] = useState(false);

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string().required('Email is required').email('Email must be a valid email address'),
  });

  const methods = useForm<FormValuesProps>({
    resolver: yupResolver(ResetPasswordSchema),
    defaultValues: { email: '' },
  });

  const { handleSubmit } = methods;

  const onSubmit = async (data: FormValuesProps) => {
    setIsLoading(true);
    try {
      await callApiWithLoading(async () => {
        const result = await commonApi.resetPassword(data.email);

        if (result) {
          if (result.loginResult === 'SUCCESS') {
            alertStore.setProps({
              open: true,
              title: '임시 비밀번호 발급 완료',
              content: '임시 비밀번호가 발급되었습니다.<br/>로그인 후 비밀번호를 변경해주세요.',
              category: 'success',
            });
            return;
          }
        }

        alertStore.setProps({
          open: true,
          title: '임시 비밀번호 발급 오류',
          content: result?.errorMessage
            ? result.errorMessage
            : '임시 비밀번호 발급에 실패했습니다.<br/>다시 시도해주세요.',
          category: 'error',
        });
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <RHFTextField name="email" label="Email address" />
      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={isLoading}
        sx={{ mt: 3 }}
      >
        임시 비밀번호 발급
      </LoadingButton>
    </FormProvider>
  );
}
